import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import "./cryptolisting.css";
import Marquee from "react-fast-marquee";
import { benefitData, experienceData, images, imagesTwo } from "./data";

const Cryptolisting = () => {
  return (
    <>
      <NewHead />

      <Helmet>
        <title>Crypto Listing Agency</title>

        <meta name="title" content="Crypto Listing Agency" />
        <meta
          name="description"
          content=" We specialize in getting your digital assets listed on top-tier exchanges, enhancing accessibility for investors and users. Our expert team ensures a smooth listing process, providing your project the exposure it deserves.            "
        />

        <meta property="og:title" content="Crypto Listing Agency" />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/crypto-listing-agency"
        />
      </Helmet>

      <main className="crp_li_main">
        {/* hero */}
        <article className="crp_li_hero crp_li_mb_150">
          <div className="primary__landing-content-container">
            <h1 className="crp_li_title">
              Crypto Listing <span className="crp_li_span">Agency</span>{" "}
            </h1>
            <p className="crp_li_content">
              Beleaf Technologies is your gateway to get into the dynamic world
              of cryptocurrencies. Our expert team specializes in all types of
              token listing services, ensuring your digital assets get the
              recognition they deserve. List your project now and attract more
              investors and traders.
            </p>

            <div className="crp_li_btn_wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="crp_li_btn"
              >
                <span className="crp_li_btn_icon">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
                <span className="crp_li_btn_text">Let’s Discuss</span>
              </button>
            </div>

            <div className="crp_li_hero_img_wrap">
              <img
                src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777273399/crptLstAgncyHeroImg_skndwu.webp"
                alt="Crypto Listing Agency"
                className="crp_li_hero_img"
              />
            </div>
          </div>
        </article>

        {/* about */}
        <article className="primary__landing-content-container crp_li_mb_150 cr_li_abt_wrap">
          <div className="row g-5 crp_li_abt_row">
            <div className="col-lg-6">
              <div className="crp_abt_wrap">
                <Marquee speed={40} autoFill>
                  {images.map((imgName, index) => (
                    <div className="crp_abt_img_wrap" key={index}>
                      <img
                        src={require(`../../../image/cryptolistingnew/${imgName}`)}
                        alt="Crypto Listing Agency"
                      />
                    </div>
                  ))}
                </Marquee>
                <Marquee
                  speed={40}
                  autoFill
                  className="crp_abt_marquee"
                  direction="ltr"
                >
                  {imagesTwo.map((imgName, index) => (
                    <div className="crp_abt_img_wrap" key={index}>
                      <img
                        src={require(`../../../image/cryptolistingnew/${imgName}`)}
                        alt="Crypto Listing Agency"
                      />
                    </div>
                  ))}
                </Marquee>
                <Marquee speed={40} autoFill>
                  {images.map((imgName, index) => (
                    <div className="crp_abt_img_wrap" key={index}>
                      <img
                        src={require(`../../../image/cryptolistingnew/${imgName}`)}
                        alt="Crypto Listing Agency"
                      />
                    </div>
                  ))}
                </Marquee>
              </div>
            </div>
            <div className="col-lg-6">
              <h3 className="crp_li_subtitle crp_abt_title">
                <span className="crp_li_span">What Is </span>
                Crypto Listing?
              </h3>
              <p className="crp_abt_content">
                A crypto listing is when a digital currency, like Bitcoin or
                Ethereum, gets officially added to a trading platform or
                exchange. It allows people to buy, sell, and trade these
                cryptocurrencies easily. Listing often increases a crypto's
                visibility and can affect its value.
              </p>
            </div>
          </div>
        </article>

        {/* specialize */}
        <article className="primary__landing-content-container crp_li_mb_120">
          <h3 className="crp_li_subtitle crp_li_sp_title">
            Token Listings We <span className="crp_li_span">Specialize In</span>
          </h3>

          <div className="crp_li_sp">
            <div className="text-center">
              <img
                src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777273399/spImgOneNew_rgvtlf.webp"
                alt="Crypto Listing Agency"
                className="crp_li_sp_img"
              />
            </div>

            <div className="row g-4 crp_li_sp_row">
              <div className="col-lg-4">
                <h3 className="crp_li_sp_bx_title">CoinMarketCap Listing</h3>
              </div>
              <div className="col-lg-8">
                <p className="crp_li_sp_bx_content">
                  CoinMarketCap Listing is like getting a golden ticket for your
                  cryptocurrency. It means your digital coin is officially
                  recognized and displayed on CoinMarketCap, a popular platform
                  that tracks and ranks cryptocurrencies. This listing boosts
                  your coin's visibility, making it easier for people to find
                  and trade. It's like being in the VIP section of the crypto
                  world, where investors and enthusiasts can easily discover and
                  trust your coin's information, contributing to its credibility
                  and success. Get your project easily listed on coinmarketcap
                  with beleaf.
                </p>
              </div>
            </div>
          </div>
          <div className="crp_li_sp crp_li_sp_two">
            <div className="row g-4 crp_li_sp_two_rw">
              <div className="col-lg-4 col-md-6">
                <div className="crp_li_sp_img_two">
                  <img
                    // src={require("../../../image/cryptolistingnew/sp-img-two.webp")}
                    src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1777273399/spImgTwoNew_f4j1gw.webp"
                    alt="Crypto Listing Agency"
                  />
                </div>
              </div>
              <div className="col-lg-8 col-md-6">
                <h3 className="crp_li_sp_bx_title">CoinGecko Listing</h3>
                <p className="crp_li_sp_bx_content">
                  Secure your place in the crypto ecosystem by getting listed on
                  CoinGecko, a trusted platform for tracking cryptocurrency
                  data. CoinGecko is a website that tracks and provides
                  information about various cryptocurrencies. When a
                  cryptocurrency is listed on CoinGecko, it means that it is
                  officially recognized and has a dedicated page displaying its
                  key details such as price, market cap, trading volume, and
                  more. This listing helps users and investors easily access and
                  analyze information about the specific cryptocurrency,
                  contributing to its visibility in the broader crypto market.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="crp_li_benefits crp_li_mb_120">
          <div className="primary__landing-content-container">
            <h3 className="crp_li_subtitle crp_ben_title">
              <span className="crp_li_span">Benefits </span>
              of Crypto Listing
            </h3>

            <div className="row g-4 crp_ben_row">
              {benefitData.map((item, index) => (
                <div className="col-lg-4 col-sm-6" key={index}>
                  <div className="crp_ben_card">
                    <img src={item.img} alt="Crypto Listing Agency" />
                    <h5>{item.title}</h5>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </article>

        {/* expertise */}
        <article className="primary__landing-content-container crp_li_mb_120">
          <h3 className="crp_li_subtitle">
            Our <span className="crp_li_span">Expertise</span>{" "}
          </h3>

          <div className="crp_li_exp">
            {experienceData.map((item, index) => (
              <div className="crp_li_exp_card" key={index}>
                <img
                  src={item.img}
                  alt="Crypto Listing Agency"
                  className="crp_exp_img"
                />
                <h5>{item.value}</h5>
                <p>{item.label}</p>
              </div>
            ))}
          </div>
        </article>

        {/* why choose */}
        <article className="primary__landing-content-container">
          <div className="crp_why">
            <h3 className="crp_li_subtitle crp_li_why_title">
              Why Choose{" "}
              <span className="crp_li_span">Beleaf Technologies</span> Crypto
              Listing Agency?
            </h3>
            <p className="crp_li_why_choose">
              At Beleaf Technologies, our Crypto Listing service stands out for
              its commitment to excellence. We combine advanced technology with
              a deep understanding of market dynamics, offering a personalized
              approach to each client. Our streamlined processes and proven
              track record make us the ideal partner for your token listing
              needs. And we are well versed in the listing field for reliability
              and commitment.
            </p>
            <div className="crp_li_btn_wrap">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="crp_li_btn"
              >
                <span className="crp_li_btn_icon crp_li_btn_bt_icon">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
                <span className="crp_li_btn_text">Talk To Our Experts</span>
              </button>
            </div>

            <img
              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1749534605/choose-img-one_trcdrh.webp"
              alt="Crypto Listing Agency"
              className="crp_ch_img_one"
            />
            <img
              src="https://res.cloudinary.com/dmjw7pe6k/image/upload/v1749534605/choose-img-two_o09oeq.webp"
              alt="Crypto Listing Agency"
              className="crp_ch_img_two"
            />
            
          </div>
        </article>

        {/* Take Away*/}
        <article className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Visibility is the key for any crypto project to be succeeded.
              Beleaf Technologies' Crypto Listing ensures your crypto project
              not only gets noticed but thrives in the competitive crypto world.
              Choose us for hassle free, effective, and transparent token
              listing experience.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn"
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </article>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          Why is Crypto Listing Important?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Crypto listing enhances your project's visibility,
                          credibility, and market access, attracting investors
                          and users.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          How Long Does the Listing Process Take?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The time frame varies but generally takes a few weeks.
                          Our team at Beleaf Technologies expedites the process
                          for timely results.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What Information is Required for Listing?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Necessary details include project documentation,
                          tokenomics, and information about the team, ensuring a
                          comprehensive listing.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          Can You Guarantee a Coin's Success Post-Listing?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          While listing increases visibility, success depends on
                          various factors. We provide the platform; the
                          project's success is a collaborative effort.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead5">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq5"
                          aria-expanded="true"
                          aria-controls="faq5"
                        >
                          Do You Offer Ongoing Support After Listing?
                        </div>
                      </div>

                      <div
                        id="faq5"
                        className="collapse"
                        aria-labelledby="faqhead5"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, our support extends beyond the listing process.
                          We offer ongoing assistance to help your project
                          thrive in the crypto space.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default Cryptolisting;
